import { axiosInstance } from '@/http-common'

export async function updateAssetSchemeMarkers(
  groupId: number | string,
  schemeId: number | string,
  markers: Array<{ type?: string; assetId?: number; address?: string; x: number; y: number; z?: number }>
): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset-group/${groupId}/scheme/${schemeId}/markers`, { markers })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function updateAssetSchemeCalibration(
  groupId: number | string,
  schemeId: number | string,
  payload: { widthM: number | null; heightM: number | null }
): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset-group/${groupId}/scheme/${schemeId}/calibration`, payload)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function replaceAssetSchemeImage(
  groupId: number | string,
  schemeId: number | string,
  file: File
): Promise<any> {
  const fd = new FormData()
  fd.append('scheme_file', file)
  return new Promise((resolve, reject) => {
    axiosInstance.post(`/api/v1/asset-group/${groupId}/scheme/${schemeId}/image`, fd)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

export async function removeAssetSchemeImage(
  groupId: number | string,
  schemeId: number | string
): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset-group/${groupId}/scheme/${schemeId}/image`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
